import { render, staticRenderFns } from "./AssignmentMap.vue?vue&type=template&id=283590c4&scoped=true&"
import script from "./AssignmentMap.vue?vue&type=script&lang=js&"
export * from "./AssignmentMap.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentMap.vue?vue&type=style&index=0&id=283590c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283590c4",
  null
  
)

export default component.exports